import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './DBDropDown.module.css';


class DBDropDown extends React.Component {

    updateField(event) {
        if (this.props.onChange) {
            this.props.onChange(event);
        }
        if (!event.isPropagationStopped()) {
            if (event.target.value === '-1') {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
            }
            else if (this.props.type === 'int') {
                this.props.updateIntField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, parseInt(event.target.value));
            } else {
                this.props.updateTextField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, event.target.value.toString());
            }
        }
    }

    render() {
        return (

            <div className={`${styles.dropdown} ${this.props.className}`}>
                {this.props.placeholderValue && (this.props.value === undefined || this.props.value === -1) && (
                    <div className={styles.placeholder}>
                        {this.props.placeholderValue}
                    </div>
                )}

                <select
                    title={this.props.title}
                    value={this.props.value !== undefined ? this.props.value : -1}
                    name={this.props.field}
                    className={this.props.className}
                    disabled={this.props.disabled}
                    onChange={(event) => this.updateField(event)}
                >
                    <option key={-1} value={-1}></option>

                    {this.props.customOptions &&
                        Object.keys(this.props.customOptions)
                            .map(id => {
                                const option = this.props.customOptions[id];
                                return (
                                    <option key={option.id} value={option.id}>{option.value}</option>
                                );
                            })
                    }
                    {!this.props.customOptions &&
                        Object.keys(this.props.options)
                            .map(id => {
                                const option = this.props.options[id];
                                return (
                                    <option key={option[this.props.masterEntityKeyColumn]} value={option[this.props.masterEntityKeyColumn]}>{option[this.props.masterEntityDisplay]}</option>
                                );
                            })
                    }
                </select>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let defaultChoise = undefined;
    let placeholderValue = ownprops.placeholder;
    if (ownprops.placeholder && ownprops.masterEntity && ownprops.masterEntityDisplay) {
        placeholderValue = state.entities.masterData[ownprops.masterEntity][ownprops.placeholder][ownprops.masterEntityDisplay];

    }
    return {
        value: (defaultChoise !== undefined) ? defaultChoise : (state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== undefined &&
            state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ?
            state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : -1),
        type: state.entities.masterData.PTERONOTESCHEMA[ownprops.entity + '.' + ownprops.field]?.DATA_TYPE,
        options: ownprops.masterEntity && ownprops.masterEntitySort && ownprops.masterEntityDisplay ?
            Object.keys(state.entities.masterData[ownprops.masterEntity])
                .sort((a, b) => state.entities.masterData[ownprops.masterEntity][b][ownprops.masterEntitySort] > state.entities.masterData[ownprops.masterEntity][a][ownprops.masterEntitySort] ? -1 : 1)
                .map(key => state.entities.masterData[ownprops.masterEntity][key]) : undefined,
        placeholderValue

    };
}

const connectedDBDropDown = connect(mapStateToProps, mapDispatchToProps)(DBDropDown);
export { connectedDBDropDown as DBDropDown };